// extracted by mini-css-extract-plugin
export var offerCardTitle = "OffersMosaic-module--offer-card-title--2f80d";